import { render, staticRenderFns } from "./cardPackage.vue?vue&type=template&id=10284951&"
import script from "./cardPackage.vue?vue&type=script&lang=js&"
export * from "./cardPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports